import { render, staticRenderFns } from "./feeitemset.vue?vue&type=template&id=0febe097&scoped=true&"
import script from "./feeitemset.vue?vue&type=script&lang=js&"
export * from "./feeitemset.vue?vue&type=script&lang=js&"
import style0 from "./feeitemset.vue?vue&type=style&index=0&id=0febe097&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0febe097",
  null
  
)

export default component.exports